import { render, staticRenderFns } from "./DictRadio.vue?vue&type=template&id=f20af9f2&scoped=true&"
import script from "./DictRadio.vue?vue&type=script&lang=js&"
export * from "./DictRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20af9f2",
  null
  
)

export default component.exports